import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { AMBIENT_SCRIBE_PLACEHOLDER_COPY as COPY } from "./ambient-scribe-purchase-placeholder.copy";

/** An email to Suno support, with the subject and a body to fill in already written. */
export function buildPurchaseHelpMailto(practiceName?: string): string {
  const subject = encodeURIComponent(
    COPY.purchaseHelpEmailSubject(practiceName)
  );
  const body = encodeURIComponent(COPY.purchaseHelpEmailBody(practiceName));
  return `mailto:${COPY.supportEmail}?subject=${subject}&body=${body}`;
}

interface PurchaseHelpContentProps {
  /** The licence's monthly price, formatted; omitted when the screen has none. */
  price?: string;
  practiceName?: string;
}

/**
 * The body of the "How to purchase" modal: why it cannot be bought here, then what to do, as
 * numbered steps. The address is a real link as well as the dialog's own button, so a reader
 * whose computer has no mail app can still see it and copy it.
 *
 * It lives in the shared confirm dialog's Redux state, so it holds no state of its own.
 */
export default function PurchaseHelpContent({
  price,
  practiceName
}: PurchaseHelpContentProps) {
  return (
    <Stack sx={{ gap: 2 }} data-testid="purchase-help-content">
      <Typography variant="body2">{COPY.purchaseHelpLead}</Typography>
      <Box component="ol" sx={{ m: 0, pl: 3, display: "grid", gap: 1.25 }}>
        <Typography component="li" variant="body2">
          {COPY.purchaseHelpStepEmail}{" "}
          <Link href={buildPurchaseHelpMailto(practiceName)} fontWeight={700}>
            {COPY.supportEmail}
          </Link>
          .
        </Typography>
        <Typography component="li" variant="body2">
          {COPY.purchaseHelpStepLicenses(price)}
        </Typography>
        <Typography component="li" variant="body2">
          {COPY.purchaseHelpStepActivate}
        </Typography>
      </Box>
    </Stack>
  );
}
